module.exports = __webpack_public_path__ + "img/inktober_2020_06_rodent.8fc0e4e1.jpg";